import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { BreadcrumbType } from '../enums/breadcrumb-type.enum';
import { Breadcrumb } from '../models/breadcrumb.interface';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private readonly breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  readonly breadcrumbs: Record<BreadcrumbType, Breadcrumb> = {
    Home: BreadcrumbType.Home,
    SearchBRC: BreadcrumbType.SearchBRC,
    SearchAS: BreadcrumbType.SearchAS,
    SearchUO: BreadcrumbType.SearchUO
  };

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.listenToRouteChanges();
  }

  private listenToRouteChanges() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const breadcrumbs = this.extractBreadcrumbsFromRoute(
          this.activatedRoute.root,
        );

        this.setBreadcrumbs(breadcrumbs);
      });
  }

  private extractBreadcrumbsFromRoute(route: ActivatedRoute): Breadcrumb[] {
    let lastChild = route;

    while (lastChild.firstChild) {
      lastChild = lastChild.firstChild;
    }

    return lastChild.snapshot.data['breadcrumbs'] || [];
  }

  getBreadcrumbs() {
    return this.breadcrumbs$.asObservable();
  }

  setBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    this.breadcrumbs$.next(breadcrumbs);
  }
}
